module.exports = __webpack_public_path__ + "static/media/ic_external.03838611.svg";